import React from 'react';
import './CriteriaRowWrapper.scss';
import BemClass from '@upsales/components/Utils/bemClass';

const CriteriaRowWrapper = ({ children, className, max800w, rowFlex }) => {
	const classes = new BemClass('CriteriaRowWrapper', className);
	return <div className={classes.mod({ max800w, rowFlex }).b()}>{children}</div>;
};
export default CriteriaRowWrapper;
